import React from 'react';

const AdminMetaContext = React.createContext(null);

export default AdminMetaContext;
